"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _addDebouncedEventListener = _interopRequireDefault(require("./../_utils/add-debounced-event-listener"));

var _waitAnimationFrame = _interopRequireDefault(require("./../_utils/wait-animation-frame"));

var _nodeBounds = require("./../_utils/node-bounds");

var _rtl = require("./../_utils/rtl");

var createGlobalScrollListener = function createGlobalScrollListener(onScroll) {
  return (0, _addDebouncedEventListener["default"])(document, "scroll", onScroll, true);
};

var createWindowResizeListener = function createWindowResizeListener(onResize) {
  return (0, _addDebouncedEventListener["default"])(window, "resize", onResize);
};

var createGloablListeners = function createGloablListeners(callback) {
  var removeScrollListener = createGlobalScrollListener(callback);
  var removeResizeListener = createWindowResizeListener(callback);
  return function () {
    removeScrollListener();
    removeResizeListener();
  };
};

var getX = function getX(_ref, origin) {
  var left = _ref.left,
      width = _ref.width;
  return {
    left: left,
    right: left + width,
    center: left + width / 2
  }[origin];
};

var getY = function getY(_ref2, origin) {
  var top = _ref2.top,
      height = _ref2.height;
  return {
    top: top,
    bottom: top + height,
    center: top + height / 2
  }[origin];
};

var calculateXandY = function calculateXandY(node, originVertical, originHorizontal) {
  var rect = (0, _nodeBounds.getNodeBounds)(node);
  return [getX(rect, (0, _rtl.getHorizontalDirection)(originHorizontal)), getY(rect, originVertical)];
};

var useElementPosition = function useElementPosition(_ref3) {
  var _ref3$elementNode = _ref3.elementNode,
      elementNode = _ref3$elementNode === void 0 ? {} : _ref3$elementNode,
      originVertical = _ref3.originVertical,
      originHorizontal = _ref3.originHorizontal;

  // Grab the initial x and y of the element. These will fall back to zero if
  // the element ref hasn't been set yet.
  var _useMemo = (0, _react.useMemo)(function () {
    return calculateXandY(elementNode.current, originVertical, originHorizontal);
  }, [elementNode, originVertical, originHorizontal]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      initialX = _useMemo2[0],
      initialY = _useMemo2[1]; // We use refs for x and y here because they are used in our
  // useLayoutEffect hook for comparison purposes only. If they
  // were values from useState, updating their value would mean
  // re-running useLayoutEffect which would create / destroy
  // the scroll event listener over and over again which would
  // take a hit on performance. Instead, we compare in the scroll
  // listener method the `newX` and `newY` against x and y's
  // current values and, if they're different, force a re-render
  // by calling forceUpdate() in order to get the new values
  // to our hook consumer


  var x = (0, _react.useRef)(initialX);
  var y = (0, _react.useRef)(initialY);

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      setState = _useState2[1];

  var forceUpdate = (0, _react.useCallback)(function () {
    return setState({});
  }, [setState]);
  (0, _react.useLayoutEffect)(function () {
    var updateXY = function updateXY() {
      var _calculateXandY = calculateXandY(elementNode.current, originVertical, originHorizontal),
          _calculateXandY2 = (0, _slicedToArray2["default"])(_calculateXandY, 2),
          newX = _calculateXandY2[0],
          newY = _calculateXandY2[1];

      if (newX !== x.current || newY !== y.current) {
        x.current = newX;
        y.current = newY;
        forceUpdate();
      }
    }; // Update the x and y after one animation frame in case the element was
    // just mounted, in which case initialX and initialY will be stale.


    (0, _waitAnimationFrame["default"])(updateXY); // Create the global listener which also returns the method
    // to remove the underlying event listener. Passing that
    // method to useLayoutEffect's return statement means that
    // the event listener will be removed whenever our component
    // unmounts.

    return createGloablListeners(updateXY);
  }, [elementNode, originHorizontal, originVertical, forceUpdate, x, y]); // Return the x & y position along with a boolean that can be used to
  // determine whether the position is actually ready (true) or whether we're
  // just returning 0, 0 because the element ref isn't initialized yet.

  return [x.current, y.current, Boolean(elementNode.current)];
};

var _default = useElementPosition;
exports["default"] = _default;